export default __webpack_public_path__ + "static/media/thick.c3f50994.svg";